export default __webpack_public_path__ + "static/media/payment_success.92427f9c.svg";